module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAARVBMVEUAAAAAw9IAuNUAws4Av8oAus4AvdAAvM4Avc0Avs4Avs4AvM4Avc4Avc4Avc0Avc4Avc4Avc4Avs4Avc4Avc4Avc4Avc6iZIhBAAAAFnRSTlMAERIVGBobOZqcoKytxs7Q0eHi5+jsoqJagwAAAGZJREFUOMvtkzsSgCAQQ6OAfPwgArn/Ua0dXOxs9LV5RTYzC2iXKZCdBkxih2QQuCgIqJkBlWIOKFaQ6EC+J2zthfEixFbY3y757/CRHSonOZ9YEbjacbhltCvDw/MeBtC+SHHxGieHsR2jmVy5AQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/asset/jilu@2x.png
// module id = tf4B
// module chunks = 0